import { JsonpClientBackend } from "@angular/common/http";
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ClienteInternacional } from "src/app/models/ClienteInternacional/ClienteInternacional";
import { ClienteInternacionalFilter } from "src/app/models/ClienteInternacional/ClienteInternacionalFilter";
import { Pais } from "src/app/models/Dte/Exportacion/Pais";
import { Proveedor } from "src/app/models/Proveedor/Proveedor";
import { ProveedorFilter } from "src/app/models/Proveedor/ProveedorFilter";
import { Receptor } from "src/app/models/Receptor/Receptor";
import { ReceptorFilter } from "src/app/models/Receptor/ReceptorFilter";
import { ClienteInternacionalService } from "src/app/services/cliente-internacional.service";
import { ClienteService } from "src/app/services/cliente.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { ProveedorService } from "src/app/services/proveedor.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";

export const ConfigClientes = {
	barraBusqueda: {
		criterios: ["Razon Social", "Rut Cliente"],
		criteriosKeys: ["razonSocial", "rutReceptorDv"],
		criterioPrincipal: "Razon Social",
	},
};
export const ConfigClientesInternacionales = {
	barraBusqueda: {
		criterios: ["Razon Social", "Identificador"],
		criteriosKeys: ["razonSocial", "codigoInterno"],
		criterioPrincipal: "Razon Social",
	},
};

export const ConfigProveedores = {
	barraBusqueda: {
		criterios: ["Razon Social", "Rut Proveedor"],
		criteriosKeys: ["razonSocial", "rut", "giro"],
		criterioPrincipal: "Razon Social",
	},
};

@Component({
	selector: "app-client-list",
	templateUrl: "./client-list.component.html",
	styleUrls: ["./client-list.component.scss"],
})
export class ClientListComponent implements OnInit {
	@Input() public ProveedorMode: boolean = false;
	@Input() public InternationalMode: boolean = false;
	@Input() public initialClients?: Receptor[];
	@Output() private clientToPass: EventEmitter<Receptor> = new EventEmitter<Receptor>();
	@Output() public hasOwnClient = new EventEmitter<boolean>();
	@Output() private receptorToPass: EventEmitter<Proveedor> = new EventEmitter<Proveedor>();
	public loading: boolean = false;
	public rowsMantenedor: any[] = [];
	private clienteFilter: ReceptorFilter = new ReceptorFilter();
	private proveedorFilter: ProveedorFilter = new ProveedorFilter();
	private internationalFilter: ClienteInternacionalFilter = new ClienteInternacionalFilter();
	private filter: any = undefined;
	public page: Page = new Page();
	public configLocal = ConfigClientes;
	private emisorId = this.tokenService.getCompany();
	private PaisesSource: Pais[] = [];
	private resultadosBusqueda?: Receptor[];

	constructor(private clientesService: ClienteService, private tokenService: TokenStorageService, private proveedorService: ProveedorService, private ClienteInternacionalService: ClienteInternacionalService, private localStorage: LocalStorageService, private ref: ChangeDetectorRef, private utilities: UtilitiesService) {}

	ngOnInit(): void {
		this.clienteFilter.emisorId = this.emisorId;
		this.proveedorFilter.emisorId = this.emisorId;
		this.proveedorFilter.activo = true;
		this.internationalFilter.emisorId = this.emisorId;
		if (this.ProveedorMode) {
			this.filter = this.proveedorFilter;
			this.configLocal = ConfigProveedores;
		} else if (this.InternationalMode) {
			this.filter = this.internationalFilter;
			this.configLocal = ConfigClientesInternacionales;
		} else {
			this.filter = this.clienteFilter;
			this.configLocal = ConfigClientes;
		}
		this.filter.activo = true;
		this.PaisesSource = this.localStorage.getPaises();
		// if(this.filter.hasOwnProperty('emisorId')){
		//   this.filter.emisorId = this.emisorId;
		// }
		this.page.pageSize = 10;
		this.page.totalElements = 0;
		this.resultadosBusqueda = this.initialClients;
		this.setPage({ offset: 0 });
	}

	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		if (this.resultadosBusqueda) {
			this.page.totalElements = this.resultadosBusqueda.length;
			this.page.totalPages = Math.ceil(this.page.totalElements / this.page.pageSize);
			const inicio = this.page.pageNumber * this.page.pageSize;
			this.rowsMantenedor = this.resultadosBusqueda.slice(inicio, inicio + this.page.pageSize);
			this.loading = false;
			return;
		}
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		if (!this.ProveedorMode && !this.InternationalMode) {
			this.clientesService.getDataByPage(this.filter, localPage).subscribe(
				(result) => {
					this.rowsMantenedor = [...result.data];
					this.setPageFromResponse(this.page, result);
					this.loading = false;
				},
				(error) => {
					this.loading = false;
					Swal.fire({
						title: "Error en lista",
						text: "No fue posible traer la lista de clientes",
						icon: "error",
					});
				}
			);
		} else if (this.ProveedorMode) {
			this.proveedorService.getDataByPage(this.filter, localPage).subscribe(
				(result) => {
					this.rowsMantenedor = [...result.data];
					this.setPageFromResponse(this.page, result);
					this.loading = false;
				},
				(error) => {
					this.loading = false;
					Swal.fire({
						title: "Error en lista",
						text: "No fue posible traer la lista de proveedores",
						icon: "error",
					});
				}
			);
		} else if (this.InternationalMode) {
			this.ClienteInternacionalService.getDataByPage(this.filter, localPage)
				.subscribe(
					(result) => {
						this.rowsMantenedor = [...result.data];
						this.setPageFromResponse(this.page, result);
						this.rowsMantenedor.forEach((row) => {
							this.getPais(row);
						});
						this.loading = false;
					},
					(error) => {
						Swal.fire({
							title: "Error en lista",
							text: "No fue posible traer la lista de clientes internacionales",
							icon: "error",
						});
					}
				)
				.add(() => {
					this.loading = false;
					this.ref.detectChanges();
				});
		}
	}

	setPageFromResponse(currentPage: Page, data: PagedResponse<any>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	searchElementsByFilter(event) {
		if (!this.ProveedorMode && !this.InternationalMode && event.busqueda?.trim()) {
			this.loading = true;
			this.clientesService.search(event.busqueda.trim(), this.emisorId).subscribe({
				next: result => {
					this.resultadosBusqueda = result.data || [];
					this.setPage({ offset: 0 });
					this.ref.detectChanges();
				},
				error: () => {
					this.loading = false;
					Swal.fire("Error en búsqueda", "No fue posible obtener los clientes.", "error");
				},
			});
			return;
		}
		this.resultadosBusqueda = undefined;
		let filterLocal = this.ProveedorMode ? new ProveedorFilter() : new ReceptorFilter();
		this.filter = { ...filterLocal };
		this.filter.emisorId = this.emisorId;
		if (this.filter.hasOwnProperty("emisorId")) {
			this.filter.emisorId = this.emisorId;
		}
		if (this.InternationalMode) this.filter.paisId = event.paisInline ? event.paisInline : "";
		this.filter[event.criterio] = event.busqueda;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.filter.activo = true;
		if (!this.ProveedorMode && !this.InternationalMode) {
			this.filter.emisorId = this.emisorId;
		}
		this.setPage({ offset: 0 });
	}

	onActivate(event) {
		if (this.loading) return;
		if (event.type == "click") {
			const rut = (event.row.rutString || "").replace(/[.\s-]/g, "");
			this.hasOwnClient.emit(!!this.resultadosBusqueda?.some(cliente => cliente.clienteId && (cliente.rutString || "").replace(/[.\s-]/g, "") === rut));
			this.clientToPass.emit(event.row);
		}
	}

	getPais(client: ClienteInternacional) {
		client.nombrePais = this.PaisesSource.find((pais) => pais.paisId == client.paisId).nombre;
	}

	cambiarTamanoPagina(tamano: number): void {
		if (this.loading || ![10, 25, 50].includes(tamano)) return;
		this.page.pageSize = tamano;
		this.setPage({ offset: 0 });
	}
}
